export function runAsyncApplication(app: () => Promise<void>) {
    const runner = async () => await app();

    runner().catch(e => console.error(e));
}